import React from "react";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaClock,
  FaHistory,
  FaShareAlt,
} from "react-icons/fa";

import { formatNumber } from "../utils/adminEventsUtils";

function StatCard({ icon: Icon, label, value, description, tone = "blue" }) {
  const styles = {
    blue: "bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200",
    green:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200",
    amber:
      "bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200",
    indigo:
      "bg-indigo-100 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-200",
    slate:
      "bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-white/70",
  };

  return (
    <article className="rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex items-start gap-3">
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${
            styles[tone] || styles.blue
          }`}
        >
          <Icon />
        </div>

        <div>
          <p className="font-titre text-3xl font-bold text-slate-950 dark:text-white">
            {formatNumber(value)}
          </p>

          <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            {label}
          </p>

          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </article>
  );
}

function EventStats({ stats }) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
      <StatCard
        icon={FaCalendarAlt}
        label="Événements"
        value={stats.total}
        description="Total enregistrés"
        tone="blue"
      />

      <StatCard
        icon={FaClock}
        label="À venir"
        value={stats.upcoming}
        description={`${stats.ongoing} en cours`}
        tone="green"
      />

      <StatCard
        icon={FaHistory}
        label="Passés"
        value={stats.past}
        description={`${stats.unknown} date inconnue`}
        tone="slate"
      />

      <StatCard
        icon={FaShareAlt}
        label="Partagés"
        value={stats.shared}
        description={`${stats.privateEvents} non partagé(s)`}
        tone="indigo"
      />

      <StatCard
        icon={FaCheckCircle}
        label="À compléter"
        value={stats.missingLocation}
        description="Lieu non renseigné"
        tone="amber"
      />
    </section>
  );
}

export default EventStats;